import styled from 'styled-components'

export const IFrameReport = styled.iframe`
  border: 0;
  height: 100vh;
  width: 100%;
`
